/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import NSWStatus from '@linc-technologies/linced-common/enums/nsw-status';

export default class StaffRoute extends Route {
  // Services
  @service
  schoolSchema;

  @service
  session;

  @service
  store;

  model() {
    let schema = this.schoolSchema;

    return hash({
      groups: schema.getPeopleSchema(),
      staff: this.store.query('person', { type: PersonType.STAFF }),
      users: this.store.query('user', {
        allowedTenantAccess: this.session.activeSchool,
        scopesUnion:
          'urn:linced:organisation:role:staff,urn:linced:organisation:role:admin',
      }),
      locations: this.store
        .query('schools/location', {
          schoolId: this.session.activeSchool,
        })
        .then((locations) => {
          // Filter active locations and then sort by name in ascending order
          return locations
            .filter((location) => location.status === NSWStatus.ACTIVE)
            .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        }),
    });
  }
}
